import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-signpost-double"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<g class=\"\"><polygon points=\"31.7,9.3 8.8,9.3 8.8,16.4 31.7,16.4 35.2,12.9 \t\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></polygon><polygon points=\"12.3,19.4 35.2,19.4 35.2,26.5 12.3,26.5 8.8,23 \t\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></polygon><line x1=\"20.7\" x2=\"20.7\" y1=\"19.4\" y2=\"16.4\" class=\"icon-fi--no-fill icon-fi--with-stroke\"></line><polyline points=\"23.3,26.5 23.3,34.7 20.7,34.7 20.7,26.5 \t\" class=\"icon-fi--no-fill icon-fi--with-stroke\"></polyline><line x1=\"23.3\" x2=\"23.3\" y1=\"16.4\" y2=\"19.4\" class=\"icon-fi--no-fill icon-fi--with-stroke\"></line></g>", 1)
  ]), 16))
}
export default { render: render }